import * as React from 'react'
import { cn } from '../lib/utils'

/**
 * forwardRef so a caller can focus it. Without it React 18 drops the ref with
 * only a console warning, and a field that is supposed to focus itself when it
 * opens silently does not — the same trap the other primitives here already
 * avoid.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          'w-full min-w-0 resize-none rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30',
          className,
        )}
        {...props}
      />
    )
  },
)

export { Textarea }
